import BookmarkIcon from '../../../../../../../assets/svgs/Bookmark'
import Facebook2Icon from '../../../../../../../assets/svgs/Facebook2'
import LinkIcon from '../../../../../../../assets/svgs/Link'
import Linkedin2Icon from '../../../../../../../assets/svgs/LinkedIn2'
import XIcon from '../../../../../../../assets/svgs/X'
import style from './style.module.css'

const AddToChatBlock = () => {
  return (
    <div className={style.companyModal_addToChat}>
      <div className={style.companyModal_addToChat_socials}>
        <a className={style.companyModal_addToChat_socials_item}>
          <XIcon />
        </a>
        <a className={style.companyModal_addToChat_socials_item}>
          <Linkedin2Icon />
        </a>
        <a className={style.companyModal_addToChat_socials_item}>
          <Facebook2Icon />
        </a>
        <a className={style.companyModal_addToChat_socials_item}>
          <LinkIcon />
        </a>
      </div>

      <div className={style.companyModal_addToChat_actions}>
        <div className={style.companyModal_addToChat_actions_save}>
          <BookmarkIcon />
        </div>

        <button className={style.companyModal_addToChat_actions_button}>
          Add to chat
        </button>
      </div>
    </div>
  )
}

export default AddToChatBlock
